export const ERROR_MVX_QUERY_FAILED = 'Querying MultiverX Smart Contract failed';
export const ERROR_MVX_API_FAILED = 'Querying MultiverX API failed';
export const ERROR_XOXNO_API_FAILED = 'Querying API failed';
export const ERROR_DATA_NOT_LOADED = 'Data is not loaded';
export const ERROR_VALUE_CANNOT_BE_NEGATIVE = 'Value cannot be negative';
export const ERROR_NOT_ENOUGH_BALANCE = 'Not enough balance';
export const ERROR_EXCEED_MAX_VALUE = 'Cannot exceeed maximum value';
export const ERROR_INVALID_VALUE = 'Invalid value';
export const ERROR_CONNECT_YOUR_WALLET = 'Connect your wallet';